'use strict'
export default {
    more: "More",
    selMatchingProducts: "Matching products",
    resMatchingProducts: "matching products",
    showResults: "Show results",
    changeFilters: "Change filters",
    topProduct: "Top Product",
    results: "Results",
    of: "of",
    init() {
        var labelEls = document.querySelectorAll(".noram-surfactants-params > .labels > input[type='hidden']");
        if (labelEls && labelEls.length > 0) {
            for (let i = 0; i < labelEls.length; i++) {
                const el = labelEls[i];
                this[el.name] = el.value;
            };
        }
    }
}